import React from "react";
import bus from "../../../admin-bus";
import { MODAL_OPEN } from "../../../action-types";

const assetOptionControl = ({ onSelection }) => {
  function onAddAssetClick(e) {
    e.preventDefault();

    window
      .fetch("/admin/assets/new", {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      .then(response => {
        response.text().then(data => {
          bus.emit(MODAL_OPEN, { content: data, onSuccess: onAddAssetSuccess });
        });
      })
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function onAddAssetSuccess(data) {
    onSelection(data.id, data);
  }

  return (
    <div className="fba-center m-small" style={{ width: "100%" }}>
      <div style={{ width: "100%" }}>
        <p className="fl-left">No existing asset? Add a new asset</p>
        <div className="fl-right pr-medium">
          <button
            className="button button--xsmall button--primary mr-small"
            onClick={e => onAddAssetClick(e)}
          >
            Add asset
          </button>
        </div>
      </div>
    </div>
  );
};

export default assetOptionControl;
